/**
 * @file targetManagement.ts
 * @module api/apiJSON/targetManagement
 * @description Defines targetManagement API request configuration and payload helpers.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026 Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 1.2.5
 */

import { IAddEditTarget, IListTargets } from "../../types";

export const targetManagementJson = {
  list: (data: IListTargets) => {
    let params: any = {
      pageNo: data.pageNo,
      limit: data.limit,
      searchTerm: data.searchTerm ? data.searchTerm : "",
      needCount: true,
    };
    if (data.targetType) {
      params.targetType = data.targetType;
    }
    if (data.roles) {
      params.roles = data.roles;
    }
    return params;
  },
  addEditTarget: (data: IAddEditTarget) => {
    return {
      target: data.target,
      type: data.type,
      notes: data.notes,
      startDate: data.startDate,
      endDate: data.endDate,
    };
  },
};
